// plugins/vue-bar.js
import Vue from 'vue'
// @ts-ignore
import Vuebar from 'vuebar'

Vue.use(Vuebar)